<p>update-license-server works!</p>
